import Swiper from 'swiper'
import 'swiper/dist/css/swiper.css'
import VanillaTilt from 'vanilla-tilt'
import CONFIG from '@js/config'
import utils from '@js/utils'

import '@js/app'
import scrollbar from '@js/scrollbar'

import '@comp/animate_title/animate_title'
import '@comp/animate_title/animate_title.scss'

import '@comp/banner_intro/banner_intro.scss'
import '@comp/banner_intro/banner_intro'

import '@comp/case_card/case_card.scss'

import '@comp/note/note.scss'
import '../../styles/components/checkbox.scss'

import './style.scss'
import { trackSection } from '@/scripts/ga'

function fetchCareerList (pageCurrent, filter, cb) {
    $.ajax({
        type: 'GET',
        url: `${CONFIG.API_BASE}career`,
        data: {
            page: pageCurrent,
            ...filter
        },
        dataType: 'json',
        success: function (msg) {
            if (msg.message) {
                return cb(new Error(msg.message))
            }
            let result = {}
            msg.forEach(row => {
                if (!result[row.department]) {
                    result[row.department] = []
                }
                result[row.department].push({
                    id: row.id,
                    location: row.location,
                    position: row.position
                })
            })

            return cb(null, result)
        },
        error: function (err) {
            console.log('err', err)
            location.href = '404.html'
        }
    })
}

function fetchFeaturedPhoto (cb) {
    $.ajax({
        type: 'GET',
        url: `${CONFIG.API_BASE}career_photos`,
        dataType: 'json',
        success: function (msg) {
            if (msg.message) {
                return cb(new Error(msg.message))
            }

            return cb(null, msg)
        },
        error: function (err) {
            console.log('err', err)
            location.href = '404.html'
        }
    })
}

$(() => {
    trackSection('Career')

    let pageCurrent = utils.getURLParam('page') || 1

    fetchFeaturedPhoto(function (err, result) {
        if (err) {
            location.href = '404.html'
            return
        }

        let featuredPhoto = ''

        result.forEach(photo => {
            featuredPhoto += `
                <div class="swiper-slide">
                    <div class="img-wrap" style="background-image: url('${photo.url}')"></div>
                </div>
            `
        })
        $('#career-swiper-container .swiper-wrapper').html(featuredPhoto)

        /* eslint-disable no-unused-vars */
        const careerSwiper = new Swiper('#career-swiper-container', {
            speed: 1000,
            autoplay: {
                delay: 3000,
                disableOnInteraction: false
            },
            navigation: {
                nextEl: '.btn-next-wrap'
            },
            slidesPerView: 2,
            slidesPerGroup: 1,
            spaceBetween: 14,
            breakpointsInverse: true,
            breakpoints: {
                768: {
                    slidesPerView: 3,
                    slidesPerGroup: 3,
                    spaceBetween: 14
                },
                992: {
                    slidesPerView: 4,
                    slidesPerGroup: 4,
                    spaceBetween: 24
                }
            },
            loop: true
        })
    })

    const caseList = [
        {
            title: 'Get to know our business',
            bgUrl: 'http://www.6e-group.com/assets/case_img1.jpg',
            desc: '',
            link: 'business.html',
            track: 'Business'
        },
        {
            title: 'People spotlight',
            bgUrl: 'http://www.6e-group.com/assets/case_img2.jpg',
            desc: '',
            link: 'javascript:;',
            track: ''
        },
        {
            title: 'Amazing works you should know',
            bgUrl: 'http://www.6e-group.com/assets/case_img3.jpg',
            desc: '',
            link: 'work.html',
            track: 'Work'
        }
    ]

    let caseListHtml = ''

    caseList.forEach((item, index) => {
        caseListHtml += `
        <div class="col-md-4 col-sm-6 col-xs-12 ${index === 1 ? '' : 'slideup'} case-card-col">
          <a href="${item.link}" class="case-card ${index === 1 ? '' : 'insight-block'} track-btn" data-track="${item.track}">
              <div class="ib-img ${index === 1 ? '' : 'tilt-link bg-hover'}">
                  <div class="ib-img-inner" style="background-image: url('${item.bgUrl}')"></div>
              </div>
              <div class="ib-content ${index === 1 ? 'pri' : 'ext'}">
                  <h4>
                      <b>${item.title}</b>
                  </h4>
              </div>
          </a>
        </div>
        `
    })

    $('#case-card-wrap').html(caseListHtml)

    VanillaTilt.init(document.querySelectorAll('.tilt-link'), {
        max: 2,
        speed: 600
    })

    $(document).on('click', '.checkbox-item a', function () {
        $(this).toggleClass('checked')
        checkCallback()
    })

    function checkCallback () {
        let location = []
        let department = []
        $('.checkbox-item a.checked').each(function () {
            if ($(this).data('location')) {
                location.push($(this).data('location'))
            }
            if ($(this).data('department')) {
                department.push($(this).data('department'))
            }
        })

        fetchCareerList(pageCurrent, { location: location, department: department }, function (err, department) {
            if (err) {
                location.href = '404.html'
                return
            }
            let careerHtml = ''
            for (var key in department) {
                careerHtml += `
                <div class="career-list-wrap">
                    <div class="career-cate"><h4>${key}</h4></div>
                    <div class="xsm-space"></div>
                    <div class="career-list">
            `
                department[key].forEach((position) => {
                    careerHtml += `
                    <a class="ext track-btn" data-track="Opening ${position.position}" href="career_detail.html?id=${position.id}">
                        <h5 class="title">${position.position}</h5>
                        <h5 class="location">${position.location}</h5>
                    </a>
                `
                })

                careerHtml += `
                    </div>
                    <div class="lsm-space"></div>
                </div>
            `
            }

            $('#career-list-wrap').html(careerHtml)
        })
    }

    fetchCareerList(pageCurrent, { location: [], department: [] }, function (err, department) {
        if (err) {
            location.href = '404.html'
            return
        }
        let careerHtml = ''
        for (var key in department) {
            careerHtml += `
                <div class="career-list-wrap">
                    <div class="career-cate"><h4>${key}</h4></div>
                    <div class="xsm-space"></div>
                    <div class="career-list">
            `
            department[key].forEach((position) => {
                careerHtml += `
                    <a class="ext track-btn" data-track="Opening ${position.position}" href="career_detail.html?id=${position.id}">
                        <h5 class="title">${position.position}</h5>
                        <h5 class="location">${position.location}</h5>
                    </a>
                `
            })

            careerHtml += `
                    </div>
                    <div class="lsm-space"></div>
                </div>
            `
        }

        $('#career-list-wrap').html(careerHtml)
    })

    scrollbar.init()
})
